import { Component } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import Container from "react-bootstrap/Container";
import moment from "moment";
import RecommendedJobsV2 from "src/components/common/MainContent/JobsTab/SearchCrossCountry/RecommendedJobsV2";
import random from "lodash/random";
import { connect } from "react-redux";
import { fetchRecommendedJobs } from "src/redux/jobs/SearchCrossCountry/action";
import MyRecruiter from "src/components/common/MainContent/Home/MyRecruiter";
import { fetchRecruiterDetails } from "src/redux/consultant/action";
import config from "src/config";
import VerifyWorkExperience from "src/components/common/OnBoarding/OnBVerifyWorkExp";
import { DashboardProps, DashboardState } from "src/components/common/MainContent/Home";
import LocationSpecialities from "src/components/common/MainContent/Home/LocationSpecialities";
import DashboardBannerV2 from "src/components/common/MainContent/Home/DashboardBannerV2";
import MainLayout from "src/components/pages/MainLayout";
import SnackbarSuccess from "src/components/common/SnackbarSuccess/SnackbarSuccess";
import { getAllWorkExperiences } from "src/redux/auth/action"

const workHistoryAutomation = config.ENABLE_WORK_HISTORY_AUTOMATION === "true";


const enableJobLocationSearch = config.ENABLE_SEARCH_JOB_LOCATION === "true";
class DashboardV2 extends Component<DashboardProps & RouteComponentProps, DashboardState> {
  constructor(props) {
    super(props);
    localStorage.removeItem("completedSteps");

    const historyPathName = localStorage.getItem("historyPathName");
    if (historyPathName?.includes("/auth/relay")) this.triggerRecruitics();

    const images = {
      am: [
        "dashboardBannerBkgrdAM1",
        "dashboardBannerBkgrdAM2",
        "dashboardBannerBkgrdAM3",
        "dashboardBannerBkgrdAM4",
        "dashboardBannerBkgrdAM6",
      ],
      pm: [
        "dashboardBannerBkgrdPM1",
        "dashboardBannerBkgrdPM2",
        "dashboardBannerBkgrdPM3",
        "dashboardBannerBkgrdPM4",
        "dashboardBannerBkgrdPM5",
        "dashboardBannerBkgrdPM6",
      ],
    };

    const amStartVal = "06:00";
    const amEndVal = "18:00";
    const amStart = moment(amStartVal, "HH:mm");
    const amEnd = moment(amEndVal, "HH:mm");
    const ampm = moment().isBetween(amStart, amEnd) ? "am" : "pm";

    this.state = {
      imgSrc: images[`${ampm}`][random(0, images[`${ampm}`].length - 1)],
      recruiterDetailsCallCounter: 0,
      recommendedJobsCallCounter: 0,
    };
  }

  componentDidMount() {
    if (window.location.pathname === "/login") return;
    window.scrollTo(0, 0);
    const {
      companyCode,
      recruiterDetails,
      atsBullhornCandidateId,
      fetchRecommendedJobs: fetchTheRecommendedJobs,
      fetchRecruiterDetails: fetchTheRecruiterDetails,
      candidateId,
      email,
      onboardingData,
      getAllWorkExperiences: fetchAllWorkExperienceRecords
    } = this.props;
    const data = {
      sort: "relevant",
      companyId: companyCode.id,
      size: config.JOB_COUNT,
      candidateId: atsBullhornCandidateId ?? null,
    };
    fetchTheRecommendedJobs(data);
    if(email)
    {
      const onboardingDataObject = {
        response: onboardingData
      };
      fetchAllWorkExperienceRecords(email, onboardingDataObject)
    }
    
    if (!recruiterDetails && candidateId) {
      fetchTheRecruiterDetails(candidateId);
    }
  }

  componentDidUpdate(prevProps) {
    if (window.location.pathname === "/login") return;
    const {
      recruiterDetails,
      candidateId,
      recruiterDetailsLoading,
      fetchRecommendedJobs: fetchTheRecommendedJobs,
      fetchRecruiterDetails: fetchTheRecruiterDetails,
      recommendedJobsCarouselItems,
      recommendedJobsLoading,
      companyCode,
      atsBullhornCandidateId,
      email,
      onboardingData,
      getAllWorkExperiences: fetchAllWorkExperienceRecords
    } = this.props;
    const { recruiterDetailsCallCounter, recommendedJobsCallCounter } = this.state;
    if (
      !recruiterDetails &&
      !recruiterDetailsLoading &&
      recruiterDetailsCallCounter < 10 &&
      candidateId
    ) {
      this.updateCounter("recruiterDetailsCallCounter", recruiterDetailsCallCounter);
      fetchTheRecruiterDetails(candidateId);
    }
    if (
      recommendedJobsCarouselItems.length === 0 &&
      recommendedJobsCallCounter < 10 &&
      !recommendedJobsLoading
    ) {
      const data = {
        sort: "relevant",
        companyId: companyCode.id,
        size: config.JOB_COUNT,
        candidateId: atsBullhornCandidateId,
      };
      this.updateCounter("recommendedJobsCallCounter", recommendedJobsCallCounter);
      fetchTheRecommendedJobs(data);
    }
    if(email && prevProps.email !== email)
    {
      const onboardingDataObject = {
        response: onboardingData
      };
      fetchAllWorkExperienceRecords(email,onboardingDataObject)
    }
  }

  getDashboard = () => {
    const { imgSrc } = this.state;
    const { recruiterDetails, verifyEmailPopUp, passwordSuccessPopUp } = this.props;
    const { t } = useTranslation();
    const componentName=t("globalSearch.location.componentDashboard");;

    return (
      <>
        {verifyEmailPopUp && <SnackbarSuccess message={t("emailVerification.success")} />}
        {passwordSuccessPopUp && (
          <span className="createPasswordSuccess">
            <SnackbarSuccess message={t("createPassword.passwordUpdated")} />
          </span>
        )}
        <div>
          {workHistoryAutomation && this.displayBanner() && (
            <div className="payRateNoteDashB">
              <VerifyWorkExperience props={undefined} />
            </div>
          )}
          <DashboardBannerV2 bgImgClass={imgSrc} />
          <Container>
            <Row>
              <Col sm={12} md={1} lg={enableJobLocationSearch?1:2} xs={12} />
              <Col sm={12} md={10} lg={enableJobLocationSearch?10:8} xs={12}>
                <LocationSpecialities translate={t} componentName={componentName} />
              </Col>
              <Col sm={12} md={1} lg={1} xs={enableJobLocationSearch?1:2} />
            </Row>
          </Container>
          <Container fluid className="mainCarousel">
            <Container className="recomdJobCardPadding">
              <h3 className="jobmasterheading">
                {t("dashboard.recommendedJobs.recommendedJobsHeadingText")}
              </h3>
              <RecommendedJobsV2 viewMyJobs={false} isRecommendedJobsOnResult={false} recommended />
            </Container>
          </Container>
          <Container fluid className="myRecruiterMain">
            <Container>
              <MyRecruiter recruiterDetails={recruiterDetails} />
            </Container>
          </Container>
        </div>
      </>
    );
  };

  triggerRecruitics = () => {
    if (sessionStorage.getItem("isRecruiticsCalled") === null) {
      sessionStorage.setItem("isRecruiticsCalled", "true");
      setTimeout(() => {
        window.rx.trigger({
          triggerName: "apply",
          applyFlowId: window.rx.getViewerId(),
        });
      }, 10000);
    }
  };

  updateCounter(counterName: string, counter: number) {
    this.setState({
      [counterName]: counter + 1,
    });
  }

  displayBanner() {
    const { onboardingWorkExp } = this.props;
    const newWorkExpWithNoEndDateArray = onboardingWorkExp?.filter((item) => {
      if (item) {
        const { workAutomationNotificationDate, isVerified } = item;
        if (!isVerified) {
          if (workAutomationNotificationDate) {
            const isSameOrBeforeDate =
              moment(workAutomationNotificationDate).isValid() &&
              moment(workAutomationNotificationDate).isSameOrBefore(moment().toDate());
            return isSameOrBeforeDate;
          }
          return true;
        }
      }
      return false;
    });

    const showBanner = newWorkExpWithNoEndDateArray?.length > 0;
    return showBanner;
  }

  render() {
    return <MainLayout component={this.getDashboard} />;
  }
}

const mapStateToProps = (state) => ({
  recommendedJobsCarouselItems: state.jobs.recommendedJobsCarouselItems,
  companyCode: state.company.company,
  candidateId: state.auth.candidateId,
  recruiterDetails: state.consultant.recruiterDetails,
  recruiterDetailsLoading: state.consultant.loading,
  recommendedJobsLoading: state.jobs.recommendedJobsLoading,
  origin: state.auth.origin,
  email: state.auth.email,
  userId: state.auth.userId,
  firstName: state.auth.firstName,
  lastName: state.auth.lastName,
  phone: state.auth.phone,
  onboardingSpecialtiesAndEducation: state.onBoarding.specialtiesAndEducation,
  onboardingWorkExp: state.onBoarding.workExperience,
  company: state.company.company,
  onboardingBasicInfo: state.onBoarding.basicInfo,
  isUserLoggedIn: state.auth.isUserLoggedIn,
  atsBullhornCandidateId: state.candidate.atsBullhornCandidateId,
  onboardingData: state.onBoarding.onboardingInformation
});

const mapDispatchToProps = (dispatch) => ({
  fetchRecommendedJobs: (obj, nav) => dispatch(fetchRecommendedJobs(obj, nav)),
  fetchRecruiterDetails: (candidateId) => dispatch(fetchRecruiterDetails(candidateId)),
  getAllWorkExperiences: (email, onboardingData) => dispatch(getAllWorkExperiences(email, onboardingData))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withRouter(DashboardV2)));
